// extracted by mini-css-extract-plugin
export default {"main":"Policy_main__EOY6l","title":"Policy_title__GEMTz","policy_container":"Policy_policy_container__M4MGn"};